import api from "../api";
import {iniciarRequisicao, logout} from "../../helpers";
import {STATUS_HTTP} from "../statusHTTP";

export const buscarCategoriasCompraPorSecao = async (params) => {
  const url = `/categorias/compras/departamentos/${params.iddepartamento}/secoes/${params.idsecao}`;
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return data.categorias.map(item => {
      return {...item, iddepartamento: params.iddepartamento, idsecao: params.idsecao};
    });
  }

  logout();
}

export const buscarDetalhamentoCategoria = async (params) => {
  const url = 'categorias/detalhamento';
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    return data.detalhamento;
  }

  logout();
}

export const buscarMovimentacoesEstoquesCategoria = async (params) => {
  const url = 'categorias/grafico-movimentacoes';
  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    return data.movimentacoes;
  }

  logout();
}

export const alterarLoteMinimo = async (requisicao) => {
  let url = 'categorias/lote-minimo'

  const {status, data} = await api.post(url, requisicao, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const alterarTempoRessuprimento = async (requisicao) => {
  let url = 'categorias/tempo-ressuprimento'

  const {status, data} = await api.post(url, requisicao, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const salvarCoberturaManual = async (requisicao) => {
  let url = 'categorias/cobertura-manual'

  const {status, data} = await api.post(url, requisicao, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}

export const buscarCaracteristicas = async (params) => {
  const url = 'categorias/caracteristicas';

  const {data, status} = await api.get(url, {params, headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    return data.caracteristicas;
  }

  logout();
}

export const salvarPrevisaoGatilho = async (requisicao) => {
  let url = 'categorias/previsao-gatilho'

  const {status, data} = await api.post(url, requisicao, {headers: iniciarRequisicao()}).catch(() => logout());

  if (status === STATUS_HTTP.OK) {
    localStorage.token = data.token;
    return true;
  }

  logout();
}
